import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './App.css';

// Layout Components
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import WhatsAppCTA from './components/common/WhatsAppCTA';
import GoogleAnalytics from './components/analytics/GoogleAnalytics';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import Services from './pages/services/Services';
import ServiceDetail from './pages/services/ServiceDetail';
import Beasiswa from './pages/beasiswa/Beasiswa';
import BeasiswaDetail from './pages/beasiswa/BeasiswaDetail';

// ScrollToTop component - handles scrolling when navigating with hash fragments
function ScrollToTop() {
  const { pathname, hash, search } = useLocation();

  useEffect(() => {
    // If it's the services page with category parameter, do nothing
    // (handled by the Services component)
    if (pathname === '/services' && search.includes('category=')) {
      return;
    }
    
    // If there's no hash in the URL, scroll to top
    if (!hash) {
      window.scrollTo(0, 0);
    } 
    // If there is a hash, scroll to the element
    else {
      // Wait a bit for the component to render
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [pathname, hash, search]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <GoogleAnalytics />
      <div className="app">
        <Helmet>
          <meta charSet="utf-8" />
          <title>#PintarPilihKuliah | Wujudkan Impian Kuliah di Luar Negeri</title>
          <meta name="description" content="Pintar Pilih Kuliah #PintarPilihKuliah menyediakan layanan end-to-end untuk memudahkan alumni pesantren mengakses pendidikan internasional melalui konsultasi beasiswa, persiapan dokumen, bimbingan tes, dan program EduTrip." />
          <meta name="keywords" content="beasiswa, pendidikan luar negeri, pesantren, kuliah internasional, konsultasi beasiswa, persiapan dokumen, persiapan tes, EduTrip" />
          <link rel="canonical" href="https://pintarpilihkuliah.github.io" />
        </Helmet>
        
        <Navbar />
        
        <main className="app-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/tentang-kami" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/layanan/:serviceId" element={<ServiceDetail />} />
            <Route path="/beasiswa" element={<Beasiswa />} />
            <Route path="/beasiswa/:slug" element={<BeasiswaDetail />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/kontak" element={<Contact />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        
        <WhatsAppCTA />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
